<template>
    <div class="el-table-container templateBox">
        <div class="query-form">
            <el-tabs v-model="auditState" type="card" @tab-click="handleClick">
                <el-tab-pane label="待审核" name=0></el-tab-pane>
                <el-tab-pane label="已审核" name=1></el-tab-pane>
            </el-tabs>
        </div>
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" label-width="80px">
            <el-form-item label="借阅目的" prop="purpose">
                <el-select style="width: 100%;" v-model="searchForm.purpose" clearable
                           placeholder="请选择借阅目的">
                    <el-option
                            v-for="item in $dictUtils.getDictList('purpose_type')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="申请人" prop="createBy">
                <el-select style="width: 100%;" v-model="searchForm.createBy" clearable placeholder="请选择申请人">
                    <el-option
                            v-for="item in applicantList"
                            :key="item.createBy"
                            :label="item.createByName"
                            :value="item.createBy">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="申请时间" prop="applicationTime">
                <el-date-picker
                        v-model="searchForm.applicationTime"
                        clearable
                        style="width: 100%"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item v-if="auditState == 1" label="审核时间" prop="auditTime">
                <el-date-picker
                        v-model="searchForm.auditTime"
                        clearable
                        style="width: 100%"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item v-if="auditState == 1" label="借阅状态" prop="applicationState">
                <el-select v-model="searchForm.applicationState" clearable placeholder="请选择借阅状态">
                    <el-option
                            v-for="item in auditResultList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="auditState == 0" label="关键字" prop="keyword">
                <el-input v-model.trim="searchForm.keyword" maxlength="20" placeholder="请输入关键字(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1,1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="text_right p_all1" v-show="auditState == 0">
            <el-button v-if="hasPermission('academic:applyFor:toExamine:through')" type="primary"
                       @click="setToexamine('','through')"
                       size="small">批量通过
            </el-button>
            <el-button v-if="hasPermission('academic:applyFor:toExamine:reject')" @click="setToexamine('','reject')"
                       size="small">
                批量驳回
            </el-button>
        </div>
        <el-table
                :data="dataList"
                v-loading="loading"
                @selection-change="selectionChangeHandle"
                @sort-change="sortChangeHandle"
                size="small" height="100%"
                class="table" ref="multipleTable" row-key='id' border>
            <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
            <el-table-column prop="applicationOdd" label="借阅编号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createByName" label="借阅人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="purpose" label="借阅目的" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ $dictUtils.getDictLabel("purpose_type", scope.row.purpose, '') }}
                </template>
            </el-table-column>
            <el-table-column prop="newApplicationContent" label="借阅内容" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicationDate" sortable label="借阅开始时间"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicationDay" sortable label="借阅天数" show-overflow-tooltip></el-table-column>
            <el-table-column prop="remark" label="备注说明" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicationNum" sortable label="借阅数量" show-overflow-tooltip
                             v-if="auditState == 1" key="adsf"></el-table-column>
            <el-table-column prop="applicationState" label="借阅状态" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ $dictUtils.getDictLabel("application_state", scope.row.applicationState, '') }}
                </template>
            </el-table-column>
            <el-table-column prop="auditByName" label="审核人" show-overflow-tooltip
                             v-if="auditState == 1"></el-table-column>
            <el-table-column prop="processOpinion" label="审核建议" show-overflow-tooltip
                             v-if="auditState == 1"></el-table-column>
            <el-table-column prop="createDate" sortable label="审核时间" show-overflow-tooltip
                             v-if="auditState == 1"></el-table-column>
            <el-table-column prop="submitByName" label="申请人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="submitTime" sortable label="申请时间" show-overflow-tooltip></el-table-column>
            <el-table-column
                    fixed="right"
                    min-width="160"
                    label="操作">
                <template slot-scope="scope">
                    <el-button v-if="hasPermission('academic:applyFor:toExamine:view')" type="text" size="small"
                               @click="view(scope.row, 'toExamineView')">详情
                    </el-button>
                    <el-button v-if="hasPermission('academic:applyFor:toExamine:through')" v-show="auditState == 0"
                               type="text" size="small"
                               @click="setToexamine(scope.row, 'through')">通过
                    </el-button>
                    <el-button v-if="hasPermission('academic:applyFor:toExamine:reject')" v-show="auditState == 0"
                               type="text" size="small"
                               @click="setToexamine(scope.row, 'reject')">驳回
                    </el-button>
                    <el-button v-if="hasPermission('academic:applyFor:toExamine:record')" type="text"
                               size="small"
                               @click="recordData(scope.row)">审核记录
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <add-borrowing ref="addBorrowing" @refresh="refreshList(1,1)"></add-borrowing>
        <audit-records ref="auditRecords"></audit-records>
        <set-toexamine ref="setToexamine" @refresh="refreshList(1,1)"></set-toexamine>
    </div>
</template>

<script>
import AddBorrowing from "@/views/modules/academic/applyFor/addBorrowing.vue";
import AuditRecords from "@/components/toExamine/auditRecords.vue";
import SetToexamine from "@/components/toExamine/setToexamine.vue";
import {toDateSize} from "@/utils";

export default {
    name: "toExamine",
    components: {SetToexamine, AuditRecords, AddBorrowing},
    data() {
        return {
            auditState: 0,
            searchForm: {
                purpose: '',
                createBy: '',
                applicationTime: [],
                submitStartTime: '',
                submitEndTime: '',
                auditTime: [],
                createStartTime: '',
                createEndTime: '',
                applicationState: '',
                keyword: '',
                current: 1,
                size: 20,
            },
            total: 0,
            applicantList: [],
            auditResultList: [
                {
                    value: 2,
                    label: '借阅中'
                },
                {
                    value: 4,
                    label: '已驳回'
                },
            ],

            loading: false,
            dataList: [],
            dataListSelect: [],
            akdnfj: [],
        }
    },

    mounted() {
        this.refreshList()
        this.getOtherList()
    },

    methods: {
        handleClick() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1)
        },

        getOtherList() {
            this.$axios(this.api.academic.resourceapplicationApplicationUserList, {}).then(data => {
                if (data && data.status) {
                    this.applicantList = data.data
                }
            })
        },

        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            if (this.searchForm.applicationTime && this.searchForm.applicationTime.length != 0) {
                this.searchForm.submitStartTime = this.searchForm.applicationTime[0]
                this.searchForm.submitEndTime = this.searchForm.applicationTime[1]
            } else {
                this.searchForm.submitStartTime = ''
                this.searchForm.submitEndTime = ''
            }
            if (this.searchForm.auditTime && this.searchForm.auditTime.length != 0) {
                this.searchForm.createStartTime = this.searchForm.auditTime[0]
                this.searchForm.createEndTime = this.searchForm.auditTime[1]
            } else {
                this.searchForm.createStartTime = ''
                this.searchForm.createEndTime = ''
            }
            let searchData = JSON.parse(JSON.stringify(this.searchForm))
            this.$delete(searchData, 'applicationTime')
            this.$delete(searchData, 'auditTime')
            this.loading = true
            this.$axios(this.api.academic.resourceapplicationAuditList, {
                ...searchData,
                auditState: this.auditState,
            }).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    this.dataList.forEach(item => {
                        let applicationList = item.applicationContent.split(',')
                        let newApplicationContent = []
                        applicationList.forEach(item2 => {
                            if (item2 == 0) {
                                newApplicationContent.push('脱敏字段')
                            }
                            if (item2 == 1) {
                                newApplicationContent.push('在线预览')
                            }
                            if (item2 == 2) {
                                newApplicationContent.push('文件下载')
                            }
                        })
                        this.$set(item, 'newApplicationContent', newApplicationContent.join(','))
                    })
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },
        //排序
        sortChangeHandle(obj) {
            obj.prop = this.getHumpLineName(obj.prop);
            if (obj.order === 'ascending') {
                this.searchForm.orderBy = obj.prop + ' asc'
            } else if (obj.order === 'descending') {
                this.searchForm.orderBy = obj.prop + ' desc'
            } else {
                this.searchForm.orderBy = ''
            }
            this.refreshList(1)
        },
        //详情 typeName view详情 edit编辑 toExamineView审核详情
        view(row, typeName) {
            if (this.auditState == 0) {
                typeName = 'toExamineView'
            } else {
                typeName = 'view'
            }
            this.$refs.addBorrowing.init(row, typeName)
        },

        //审核记录
        recordData(row) {
            this.$refs.auditRecords.init(row.id)
        },

        //type through通过 reject驳回
        setToexamine(row, type) {
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let url = this.api.academic.resourceapplicationAudit
            let ids = list.map(item => {
                return item.auditId
            })
            if (type == 'through') {
                let year = new Date().getFullYear();
                const month = new Date().getMonth() + 1;
                const day = new Date().getDate();
                let dataGoOver = list.filter(item => {
                    return this.toDateSize(year + '-' + month + '-' + day, item.applicationDate)
                })
                if (dataGoOver.length) {
                    this.$confirm(`借阅开始时间必须等于或大于当前时间！`, '提示', {
                        confirmButtonText: `${ids.length == 1 ? '驳回' : '全部驳回'}`,
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        //驳回
                        this.$refs.setToexamine.init(ids, 'reject', url, {
                            auditState: 4
                        })
                    })
                } else {
                    //通过
                    this.$refs.setToexamine.init(ids, type, url, {
                        auditState: 2
                    })
                }
            } else {
                //驳回
                this.$refs.setToexamine.init(ids, type, url, {
                    auditState: 4
                })
            }
        },
    },
}
</script>

<style scoped>

</style>
